import styled from 'styled-components';
import {
    Text,
} from '@cashfree-intl/coherent';

export const StyledText = styled(Text)`
  width: max-content;
`;